// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"18728f1b","359":"184daf0e","448":"3a7a2ba1"}[chunkId] + ".chunk.css";
};